<template>
<v-layout row wrap >
  <!-- <vuex-loader :request-id='reqId' ></vuex-loader> -->
  <request-status :request='saveRequest' class='mt-0' />
  <request-status :request='globalRequests.appointmentsv2' :message200='false' />
  <!-- <request-status :request='getRequest' :message200='false' /> -->

  <v-flex xs12 >
    <practitioner-picker
      v-if='practitioner'
      v-model='practitioner' />
    <v-divider/>
  </v-flex>

  <!-- <v-flex xs12 sm6
    id="appointment-success-container"
    v-if='isSuccess' >

    <appointments-after-actions
      @close='$emit("close")'
      @reset='clear'
      :appointment='savedAppointment' >
    </appointments-after-actions>
  </v-flex> -->
  <v-flex xs12 sm6 id="appointment-create-container" >
    <v-window v-model="step" touchless vertical :min-height='500' >
      <v-window-item >
      <v-sheet height="100%" :min-height='500' flat >
      <!-- create the appointment -->
        <v-layout >
          <v-flex xs6 class='px-1'>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small block tile
                  v-bind="attrs"
                  v-on="on"
                  @click='appointment.is_custom=false'
                  :outline='appointment.is_custom' color='accent' >Normal appointment</v-btn>
              </template>
              <span>Use this when creating a normal appointment for a client</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs6 class='pl-1 mr-2'>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small block tile
                v-bind="attrs"
                v-on="on"
                @click='appointment.is_custom=true'
                :outline='!appointment.is_custom' color='accent' >Personal appointment</v-btn>
            </template>
            <span>Use this to create an appointment for yourself - you can use this to block time out from your calendar</span>
          </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout >
          <v-flex xs12 class='px-2' >
            <v-text-field v-if='appointment.is_custom' persistent-hint
              name="input-title"
              label="Appointment title"
              hint="Give the appointment a name. e.g.: Lunch, Yoga, Gym, Meeting with Jane etc."
              v-model='appointment.title'
              class='mb-1'
              id="appointment-title" />
          </v-flex>
        </v-layout>
        <v-divider/>

        <v-list two-line avatar subheader :class="{'mb-4': $vuetify.breakpoint.xs}" >
          <v-list-tile
            v-if='!appointment.is_custom' @click.native="productpicker=!productpicker"
            :class='getStepClasses("product")' >

            <v-list-tile-avatar>
                <v-icon>star</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <!-- {{appointment.product}} -->
                <v-list-tile-title v-if='appointment.product && appointment.product.title' >
                  {{appointment.product.title}}
                </v-list-tile-title >
                <v-list-tile-title v-else >
                  Type of appointment
                </v-list-tile-title>

                <v-list-tile-sub-title v-if='appointment.product && appointment.product.duration'>
                  {{appointment.product.duration}} mins.
                  {{appointment.product.currency}} {{appointment.product.price}}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  v-if='selectedServiceTitle' >@ {{selectedServiceTitle}}
                  <v-chip outline label v-if='appointment && appointment.address' class='v-chip--x-small' >
                    <v-icon left small >location_on</v-icon>
                    {{appointment.address.name}}</v-chip>
                </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-divider vertical />
            <v-list-tile-action >
                <v-icon v-if='appointment.product && appointment.product.title' color='success'>task_alt</v-icon>
                <v-icon v-else color='info' >arrow_back</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <!-- <pre v-text='appointment.product' /> -->
          <v-list-tile v-if='appointment && appointment.product && appointment.product.comes_to_you === true' >

              <v-text-field prepend-icon='location_on' class='mx-4'
                v-model='appointmentLocation'
                label='Appointment Address'
                hint='(optional), store the custom address for this appointment' />

          </v-list-tile>

          <template v-if='appointment && appointment.product && appointment.product.is_online === true' >
            <v-divider/>
            <div v-if='hasZoomIntegration'
              class='caption amber lighten-2 mx-4' >
              <v-icon class='mt-2 mr-2 float-left' style='float:left;' small>info</v-icon>
              <v-btn
                @click="overrideZoomIntegration=true"
                style="float:right;height:24px;" class='caption py-0 px-1' outline >Manually enter meeting URL</v-btn>
              Zoom integration detected.<br/>
              A Zoom meeting will be created for this appointment
            </div>
            <v-list-tile v-if="!hasZoomIntegration || overrideZoomIntegration" >
                <v-text-field persistent-hint
                  prepend-icon='language' class='mx-4 caption'
                  v-model='appointmentURL'
                  label='Provide a meeting URL'
                  hint="(optional) If you don't have the Zoom integration, you can manually provide a meeting URL, or you can provide a custom URL if you do not want AppointmentGuru to generate a custom Zoom meeting for you" />

            </v-list-tile>
            <v-divider/>
          </template>

          <!-- day -->
          <v-list-tile
            :class='getStepClasses("day")'
            @click='daymodal=true' >
            <v-list-tile-avatar >
              <v-icon >event</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-if='!appointment.day' >Day</v-list-tile-title>
              <v-list-tile-title v-else >
                {{dateformat(appointment.day, 'ddd DD MMM')}}
              </v-list-tile-title>
              <v-list-tile-sub-title>click to change selected day</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-tooltip right :value='true' >
              <template v-slot:activator="{ on }">
                <v-btn fab small fixed bottom left
                  @click.stop='showcalendar=true' v-on="on"
                  class='mb-5 hidden-sm-and-up' color='info' >
                  <v-icon >event</v-icon>
                </v-btn>
              </template>
              <span>Show schedule</span>
            </v-tooltip>

            <v-divider vertical />
            <v-list-tile-action >
              <v-icon v-if='appointment.day' color='success' >task_alt</v-icon>
              <v-icon v-else color='info' >arrow_back</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-dialog v-model="daymodal" lazy width='325' >
            <v-card flat >
              <v-date-picker full-width
                v-model="appointment.day" scrollable actions autosave >
                <v-spacer></v-spacer>
                <v-btn flat @click="daymodal=false">Done</v-btn>
              </v-date-picker>
            </v-card>
          </v-dialog>

          <!-- time -->
          <v-divider></v-divider>
          <v-list-tile
            :class='getStepClasses("time")'
            @click='starttime=true' >
            <v-list-tile-avatar>
                <v-icon>access_time</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content >
                <v-list-tile-title style='height:32px;'>
                  <v-dialog v-model="starttime" lazy width='325'  >
                    <v-chip
                      @click='setDefaultStartTime'
                      small slot='activator' >
                      <span v-if='!appointment.start_time' >Start time</span>
                      <span v-else >{{appointment.start_time}}</span>
                    </v-chip>
                    <v-card flat>
                      <v-time-picker class='elevation-0' full-width
                        @input='startTimeChanged'
                        v-model="appointment.start_time" scrollable format="24hr" autosave >
                      </v-time-picker>
                      <v-card-actions>
                        <v-btn @click='starttime = false' flat >Done</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @click='starttime = false; endtime = true' >Choose end time <v-icon>arrow_forward</v-icon></v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-icon small>arrow_forward</v-icon>
                  <v-dialog v-model="endtime" lazy width='325' >
                    <v-chip
                      @click.prevent='setDefaultEndTime'
                      small slot='activator' >
                      <span v-if='!appointment.end_time' >End time</span>
                      <span v-else >{{appointment.end_time}}</span>
                    </v-chip>
                    <v-card flat >
                      <v-time-picker class='elevation-0' full-width v-model="appointment.end_time" :min='appointment.start_time' scrollable format="24hr" autosave >
                      </v-time-picker>
                      <v-card-actions>
                        <v-btn flat @click='endtime = false; starttime = true' ><v-icon>arrow_back</v-icon>Change start time</v-btn>
                        <v-btn @click='endtime = false' flat >Done</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Choose a start and end time
                </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-divider vertical />
            <v-list-tile-action >
              <v-icon v-if='appointment.start_time && appointment.end_time' color='success' >task_alt</v-icon>
              <v-icon v-else color='info' >arrow_back</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>

          <!-- show operating hours -->
          <div flat v-if='isProductSelected' class='overline pl-4 grey lighten-4' >
                <v-menu nudge-bottom absolute right >
                  <template v-slot:activator="{ on }">
                    <template v-if='operatingHours' style='text-align:center;' >
                      <v-icon color='primary' small class='hidden-xs-only' >alarm</v-icon>
                      <v-chip label outline class='v-chip--x-small' >{{ practitionerName }}</v-chip>
                      {{ dateformat(appointment.day, 'ddd') }}
                      @ {{appointment.address.name}}:
                      <strong>{{selectedDayHours}}</strong>
                      <v-btn v-on='on' slot='activator' small icon >
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <template v-else style='text-align:center;' >
                      <v-icon small class='mr-2' color='amber' >warning</v-icon>
                      Unable to load operating hours
                      <v-spacer/>
                      <v-btn flat small
                        v-if='operationHoursLink && appointmentServiceId'
                        :href="operationHoursLink" target="_blank"
                        :disabled="!rolesIsOwnerOfSpace(appointmentServiceId)" >Edit hours</v-btn>
                    </template>
                  </template>
                  <v-list subheader dense class='pa-0'
                    v-if='operatingHours' >
                    <v-subheader class='overline py-0 my-0' >
                      <!-- {{operatingHours.title}} -->
                      {{practitionerName}} @ {{appointment.address.name}}:
                      <!-- {{operatingHours.id}} -->
                      <v-spacer></v-spacer>
                      <v-btn small icon class='mr-0' >
                        <v-icon small>close</v-icon>
                      </v-btn>
                    </v-subheader>
                    <v-divider></v-divider>
                    <template v-for='day in days' >
                      <v-list-tile :key='day' >
                        <v-list-tile-content class='text-capitalize' >
                          <v-list-tile-title
                            v-if='day in operatingHours && operatingHours[day]' >
                            <strong >{{day}}</strong>
                            <div style='float:right; padding-left:20px;' >
                              {{ formatHours(operatingHours[day]) }}
                            </div>
                          </v-list-tile-title>
                          <v-list-tile-title v-else >
                            <strong >{{day}}</strong>
                            <div style='float:right;padding-left:20px;' >Not available</div>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider :key='`div-${day}`'/>
                    </template>
                    <v-divider/>
                    <v-list-tile
                      v-if='operationHoursLink && appointmentServiceId' >
                      <v-btn block small flat
                        :href="operationHoursLink"
                        :disabled="!rolesIsOwnerOfSpace(appointmentServiceId)"
                        target="_blank" >Edit hours
                        <v-icon small class='ml-2' >open_in_new</v-icon>
                      </v-btn>
                    </v-list-tile>
                  </v-list>
                </v-menu>
          </div>
          <!-- <pre v-text='selectedRelationship' /> -->
          <!-- choose a client -->

          <v-list-tile
            v-show='!appointment.is_custom && isProductSelected'
            @click="clientmodal=true;clientToucher++" :class='getStepClasses("client")'  >
            <v-list-tile-avatar>
              <v-icon >person_add</v-icon>
            </v-list-tile-avatar>
            <!-- <pre>{{storeClient}}</pre> -->
            <v-list-tile-content>
                <v-list-tile-title
                  v-if="appointment.client && appointment.client.first_name" >
                  {{ formatFullName(selectedRelationship) }}
                </v-list-tile-title>
                <v-list-tile-title v-else >Contact person</v-list-tile-title>
                <v-list-tile-sub-title>
                  Click to change</v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="appointment.client && !clientIsSharedWithSelectedSpace"
                  class='warning--text'>
                  <v-icon small >info</v-icon>
                  This client will automatically be shared with the space {{appointmentServiceTitle}}
                </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action v-if='relationshipId && practitionerId && appointment.day' >
              <automation-indicator
                :relationship-id='relationshipId'
                :practitioner-id='practitionerId'
                :product-id='formattedAppointment.product'
                :dt='appointment.day' />
            </v-list-tile-action>
            <v-list-tile-action
              v-if='relationshipId'
              @click.stop="editClient" >
                <v-icon >edit</v-icon>
            </v-list-tile-action>
            <v-divider vertical class='ml-2' />
            <v-list-tile-action >
              <v-icon v-if='appointment.client && appointment.client.id' color='green'>task_alt</v-icon>
              <v-icon v-else color='info' >arrow_back</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <div
            v-if='appointment.client && appointment.client.id'
            class='overline pl-3 pt-1 grey lighten-4' >
            <v-divider/>
            <template v-if='!hasContacts' >
                <v-chip
                outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning'>
                <v-icon small >warning</v-icon>
                No contact info
              </v-chip>
            </template>
            <template v-else>
              <v-chip outline outlined label
                v-if='clientPhoneNumber'
                @click.stop='editClient' color='primary' class='v-chip--x-small' >
                {{clientPhoneNumber}}
                <!-- <v-icon small right outlined >phone</v-icon> -->
              </v-chip>
              <v-chip v-else outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning' >
                <v-icon small >warning</v-icon>
                No phone no.
              </v-chip>

              <v-chip outline outlined label
                v-if='clientEmail'
                @click.stop='editClient'
                color='primary' class='v-chip--x-small' >
                {{ clientEmail }}
                <!-- <v-icon small right >send</v-icon> -->
              </v-chip>
              <v-chip v-else outline outlined label
                @click.stop='editClient'
                class='v-chip--x-small'
                color='warning' >
                <v-icon small >warning</v-icon>
                No email
              </v-chip>
            </template>
            <v-divider/>
          </div>

          <v-dialog :fullscreen="true" v-model="clientmodal" lazy full-width >

            <client-picker-dialog
              @clientselected='clientSelected'
              @relationshipselected='relationshipSelected'
              @close='clientmodal=false'
              :can-clear-space='false'
              :space-id='spaceId'
              :include-owned-by-me='true'
              :touch='clientToucher' >
            </client-picker-dialog>

          </v-dialog>

          <section v-if='appointment.client && appointment.client.first_name' >
            <v-layout>
              <v-flex class='text-xs-right'>
                <v-spacer></v-spacer>
                  <v-btn
                    class='my-0'
                    v-if='!selectCustomTitle'
                    @click='selectCustomTitle = true' flat small  >
                      <v-icon small >add</v-icon>
                      Add a dependant</v-btn>
                  <v-btn v-else
                    @click='selectCustomTitle = false; appointment.title = ""'
                    flat small >Cancel</v-btn>
              </v-flex>
            </v-layout>
            <template v-if='selectCustomTitle' >
              <v-text-field outline persistent-hint
                class='mx-3'
                name="input-title"
                hint="Dependant's name will show on calendar and invoices. Appointment is attached to the contact person's account"
                label="Dependant's full name"
                v-model='appointment.title'
                id="appointment-title" >
              </v-text-field>
                <!-- <v-list-tile >
                  <v-list-tile-content>
                    <v-text-field
                      name="input-title"
                      label="Dependant's full name"
                      v-model='appointment.title'
                      id="appointment-title" ></v-text-field>
                    <v-list-tile-sub-title >
                      Dependant's name will show on calendar and invoices.
                      Appointment is attached to the contact person's account
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile> -->
            </template>
          </section>

          <!-- warnings/notifications -->
          <!-- <v-list-tile
            v-if='appointment.start_time && appointment.end_time &&
                  appointment.recurring &&
                  recurringVerifyRequestStatus === 200 &&
                  recurringVerifyRequest.result &&
                  recurringVerifyRequest.result.data &&
                  recurringVerifyRequest.result.data.clashes &&
                  recurringVerifyRequest.result.data.clashes.length > 0' >
            <v-list-tile-avatar >
              <v-icon >warning</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{recurringVerifyRequest.result.data.clashes.length}}
                Clashing appointments detected
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar >
              <v-dialog v-model="recurranceIntervalPicker" lazy >
                <v-btn slot='activator' flat >Show</v-btn>
                <v-list subheader>
                  <v-subheader>Clashing appointments</v-subheader>
                  <template v-for="appointment in recurringVerifyRequest.result.data.clashes" >
                    <appointment-list-item
                      :key='appointment.id'
                      :appointment='appointment' >
                    </appointment-list-item>
                    <v-divider :key='`d-${appointment.id}`'></v-divider>
                  </template>
                </v-list>
              </v-dialog>
            </v-list-tile-avatar>
          </v-list-tile> -->

          <v-layout>
            <v-flex class='text-xs-right' >
              <span v-if='appointmentIsValid && selectCustomTitle' class='mr-4'>
                <v-icon small >info</v-icon>
                Appointment will be stored under {{clientFirstName}}
              </span>
            </v-flex>
          </v-layout>

          <v-list-tile v-if='!appointmentIsValid' >
            <v-list-tile-avatar >
              <v-icon color='orange' >warning</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-sub-title class='orange--text' >
              {{invalidReason}}
            </v-list-tile-sub-title>
          </v-list-tile>

          <!-- <div v-if='appointment.day'
            class='text-center' >
            <v-chip @click='showcalendar=true' class='text-center' >
              <v-icon left >event</v-icon>
              Show schedule
            </v-chip>
          </div> -->

          <read-only-block
            v-if='$store.getters.isReadOnly === true' xs12
            text='This account is in read-only mode. Please resolve the account status in order to create new appointments' >
          </read-only-block>

        </v-list>
      </v-sheet>
      </v-window-item>

      <v-window-item>

        <transition name="fade" >
          <appointments-after-actions
            v-if='savedAppointment && savedAppointment.id'
            @close='$emit("close")'
            @reset='clear'
            :appointment='savedAppointment' >
          </appointments-after-actions>
        </transition>

      </v-window-item>
    </v-window>
    <v-card-actions
      v-show='step===0'
      :class='mobileCardActionsClasses' :style='mobileCardActionsStyles' >
      <v-btn block
        @click='confirmAndCreate=true'
        color='primary'
        :loading='saveRequest.loading'
        :disabled='!appointmentIsValid' >Confirm and create</v-btn>
    </v-card-actions>
  </v-flex>

  <v-flex class='hidden-xs-only' xs12 sm6>
    <v-card flat>
      <v-divider></v-divider>
      <practitioner-day-view with-week with-date-bar block-events
        v-if='appointment.day'
        :with-fetch='false'
        :practitioner='practitioner'
        :date.sync='appointment.day'
        :settings='dayViewSettings'
        :preview-event='appointmentPreview'
        @dayview:createevent='slotSelected'
        class='mr-3 mt-2 elevation-10' />
    </v-card>
  </v-flex>

  <!-- v-if='$vuetify.breakpoint.xs' -->
  <v-dialog fullscreen hide-overlay scrollable
    transition="dialog-bottom-transition"
    v-model='showcalendar' v-if='$vuetify.breakpoint.xs' >
    <v-card v-if='appointment.day' flat tile >
      <v-card-title class='overline grey darken-4 py-1 white--text' >
        Schedule for {{ dateformat(appointment.day) }}
        <v-spacer/>
        <v-btn @click='showcalendar=false' icon small dark ><v-icon small dark >close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <practitioner-day-view with-week with-date-bar block-events
          v-if='appointment.day'
          :with-fetch='false'
          :practitioner='practitioner'
          :date.sync='appointment.day'
          :settings='dayViewSettings'
          :preview-event='appointmentPreview'
          @dayview:createevent='slotSelected' />
      <v-fab-transition>
        <v-btn fab small fixed bottom right
          @click='showcalendar=false'
          v-show='sheetdateselected'
          class="success" >
          <v-icon>check</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card>
  </v-dialog>

  <product-sheet
    :visible='productpicker'
    :practitioner='practitioner'
    @selectedservice='productSelected' >
  </product-sheet>

  <v-bottom-sheet v-model='confirmAndCreate' inset >
    <confirm-appointment
      :practitioner='practitioner'
      :appointment='appointment'
      :loading='saveRequest.loading'
      @close='confirmAndCreate=false'
      @confirm='confirmAndSave' />
  </v-bottom-sheet>
</v-layout>
</template>

<script>
import moment from 'moment'
import ReadOnlyBlock from '@/components/app/ReadOnlyBlock'
import ProductSheet from '@/components/pickers/ProductSheet'
import ClientPickerDialog from '@/components/pickers/ClientPickerDialog'
import PractitionerDayView from '@/components/calendar/PractitionerDayView'
import AppointmentsAfterActions from '@/components/appointment/actions/After'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import PractitionerPicker from '@/components/pickers/PractitionerPicker.vue'
import ConfirmAppointment from '@/components/appointment/Confirm.vue'
import AutomationIndicator from '@/components/appointment/AutomationIndicator.vue'
import AppointmentCard from '@/components/cards/AppointmentCard.vue'
import {mapGetters} from 'vuex'
import Vue from 'vue'

import {
  SET_SETTING,
  CREATE_APPOINTMENT_REQ,
  LINKS
  // LIST_APPOINTMENTS_IN_RANGE_REQ
} from '@/store/constants'

export default {
  name: 'AppointmentQuickCreate',
  components: {
    ReadOnlyBlock,
    ProductSheet,
    PractitionerListItem,
    PractitionerPicker,
    ClientPickerDialog,
    PractitionerDayView,
    AppointmentsAfterActions,
    AutomationIndicator,
    AppointmentCard,
    ConfirmAppointment
  },
  props: {
    value: { type: Object, default: () => { return {} } },
    relationship: { type: Object, required: false },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      step: 0,
      reqId: CREATE_APPOINTMENT_REQ,
      timeout: null,
      LINKS,
      // dayviewReqId: LIST_APPOINTMENTS_IN_RANGE_REQ,
      reqClashCheckId: 'request-check-for-clashes',
      clientToucher: 1,
      daymodal: false,
      showcalendar: false,
      starttime: false,
      endtime: false,
      productpicker: false,
      clientmodal: false,
      invalidReason: false,
      sheetdateselected: false,
      overrideZoomIntegration: false,
      appointmentURL: null,
      // recurranceIntervalPicker: false,
      confirmAndCreate: false,
      ignoredStatuses: ['c'],
      appointmentLocation: null,
      practitioner: { id: null },
      days: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      savedAppointment: null,
      appointment: {
        resetting: false, // tops updates to daterange
        title: null,
        create_process: true,
        day: moment().format('YYYY-MM-DD'),
        start_time: null,
        end_time: null,
        is_custom: false,
        product: {},
        service: {},
        client: {},
        relationship: {},
        recurring: false,
        recurrance: {
          count: 4,
          interval: 'Weekly'
        }
      },
      selectedRelationship: {},
      selectCustomTitle: false,
      nextfield: null
    }
  },
  mounted () {
    if (!this.practitioner) {
      this.practitioner = this.me
    }
  },
  methods: {
    confirmAndSave (confirmationData) {
      this.appointment = Object.assign(this.appointment, confirmationData)
      this.save()
      this.confirmAndCreate = false
    },
    save () {
      this.$emit('quickcreate:save', this.formattedAppointment)

      let data = this.formattedAppointment
      // format dates to UTC
      // data.start_time = moment(data.start_time).utc().format('YYYY-MM-DD HH:mm')
      // data.end_time = moment(data.end_time).utc().format('YYYY-MM-DD HH:mm')
      data.source = process.env.APP_NAME
      if (!this.appointment.recurring) {
        this.$appointmentguru
          .resource('appointment')
          .id(this.reqId)
          .create(JSON.stringify(data))
      } else {
        let data = {
          start_time: this.formattedAppointment.start_time,
          end_time: this.formattedAppointment.end_time,
          practitioner: this.me.id,
          num_recurrances: this.appointment.recurrance.count,
          recurrance_rate: this.appointment.recurrance.interval.toUpperCase(),
          appointment: this.formattedAppointment
        }
        this.$appointmentguru
          .resource('appointment.recurring')
          .id(this.reqId)
          .create(JSON.stringify(data))
      }
      this.$ga.event('appointment', 'created')
    },
    recurringTest () {
      let start = this.timeStringToMoment(this.appointment.start_time, this.appointment.day).utc().format('YYYY-MM-DD HH:mm')
      let end = this.timeStringToMoment(this.appointment.end_time, this.appointment.day).utc().format('YYYY-MM-DD HH:mm')
      let data = {
        practitioner: this.me.id,
        start_time: start,
        end_time: end,
        num_recurrances: this.appointment.recurrance.count,
        recurrance_rate: this.appointment.recurrance.interval.toUpperCase()
      }
      this.$appointmentguru
        .resource('appointment.recurring.clashes')
        .id(this.reqClashCheckId)
        .create(data)
    },
    clear () {
      // set appointment.resetting so as not to trigger
      // date range update when we reset the form
      this.selectCustomTitle = false
      this.appointment.resetting = true

      this.appointment.title = null
      this.appointment.create_process = true
      // this.appointment.day = moment().format('YYYY-MM-DD')
      this.appointment.start_time = null
      this.appointment.end_time = null
      this.appointment.is_custom = false
      this.appointment.product = {}
      this.appointment.service = {}
      this.appointment.client = {}
      this.appointment.relationship = {}
      this.appointment.recurring = false
      this.appointment.zoom_join_url = null
      this.appointment.recurrance = {
        count: 4,
        interval: 'Weekly'
      }
      if (this.globalPractitioner && this.globalPractitioner.id) {
        this.practitioner = this.globalPractitioner
      } else {
        this.practitioner = this.me
      }
      this.appointment.resetting = false
      this.savedAppointment = false
      this.appointmentURL = null
      this.overrideZoomIntegration = false
    },
    productSelected (payload) {
      if (payload && payload.product) {
        this.appointment.product = payload.product
        this.appointment.service = payload.service
        this.appointment.address = payload.location
        this.productpicker = false

        if (this.appointment.start_time) {
          if (!this.appointment.end_time) {
            this.startTimeChanged(this.appointment.start_time)
          }
        }
      }
    },
    editClient () {
      if (this.relationshipId) {
        this.launchCustomerDetailsDialog(this.relationshipId, true)
      }
    },
    clientSelected (client) {
      this.appointment.client = client
      this.clientmodal = false
      if (!this.hasContacts) {
        this.appointment.create_process = false
      }
    },
    relationshipSelected (rel) {
      this.selectedRelationship = rel
      Vue.set(this.appointment, 'relationship', rel)
    },
    slotSelected (evt) {
      this.sheetdateselected = true
      if (this.isSuccess) { this.clear() }
      this.appointment.day = moment(evt.start_time).format('YYYY-MM-DD')
      this.appointment.start_time = evt.start
      // this.appointment.end_time = evt.end
      if (this.appointment.product && this.appointment.product.duration) {
        this.startTimeChanged(evt.start)
      } else {
        Vue.set(this.appointment, 'end_time', evt.end)
      }
    },
    startTimeChanged (time) {
      if (this.appointment.product && this.appointment.product.duration) {
        let datetimeString = this.timeStringToMoment(time, this.day)
        let endTimeMoment = moment(datetimeString).add(this.appointment.product.duration, 'minutes')
        this.appointment.end_time = endTimeMoment.format('HH:mm')
      }
    },
    formatHours (hours) {
      if (hours) {
        return hours.split('|').join(', ')
      }
      return ''
    },
    moveDay (days) {
      if (this.appointment.day) {
        this.appointment.day = moment(this.appointment.day)
          .add(days, 'days')
          .format('YYYY-MM-DD')
      }
    },
    setDefaultStartTime () {
      if (!this.appointment.start_time) {
        this.appointment.start_time = moment().startOf('hour').format('HH:mm')
      }
    },
    setDefaultEndTime () {
      if (!this.appointment.end_time) {
        this.appointment.end_time = moment().startOf('hour').add(1, 'hour').format('HH:mm')
      }
    },
    debounceGetAppointmentsForDay (delay) {
      if (!delay) { delay = 250 }
      if (this.timeout) { window.clearTimeout(this.timeout) }
      this.timeout = window.setTimeout(this.getPractitionerAppointments, delay)
    },
    getAppointmentsForDay () {
      this.getPractitionerAppointments(this.practitionerId, this.appointment.day, this.appointment.day)
    },
    getStepClasses (step) {
      if (step === this.nextfield) { return 'elevation-5 accent lighten-3' }
      return []
    }
  },
  watch: {
    isSuccess () {
      console.log('success', this.isSuccess)
      if (this.isSuccess) {
        this.step = 1
      } else {
        this.step = 0
      }
    },
    dialogVisibility () {
      // console.log(this.dialogVisibility)
      this.clear()
    },
    showcalendar () {
      if (this.showcalendar === true) { this.sheetdateselected = false }
    },
    saveRequestStatus () {
      // let okResponses = [200, 201]
      // if (this.saveRequestStatus &&
      // okResponses.indexOf(this.saveRequestStatus) !== -1) {
      if (this.saveRequestStatus === 201) {
        let vm = this
        // debounce(() => {
        // console.log(SET_SETTING)
        vm.savedAppointment = vm.saveRequest.result.data
        vm.$emit('success', vm.saveRequest)
        if (!this.appointment.recurring) {
          this.$store.commit('addAppointments', [vm.savedAppointment])
        }
        if (this.appointment && this.appointment.day) {
          this.$store.commit('setCalendarDate', this.appointment.day)
        }
        // this.getAppointmentsForDay()
        // vm.clear()
        // }, 1000)
      }
    },
    spaceId () {
      this.appointment.client = null
    },
    globalStartTime () {
      this.appointment.day = moment(this.globalStartTime).format('YYYY-MM-DD')
      this.appointment.start_time = moment(this.globalStartTime).format('HH:mm')
    },
    globalPractitioner () {
      if (this.globalPractitioner) {
        this.practitioner = this.globalPractitioner
        // clear the global practitioner
        this.$store.commit(SET_SETTING, ['activePractitioner', null])
      }
    },
    isCustomEvent () {
      if (this.isCustomEvent === true) {
        this.appointment.create_process = false
      } else {
        this.appointment.create_process = false
      }
    },
    // selectedDate () {
    //   if (this.appointment.resetting === true) { return false }
    //   this.$store.commit(SET_SETTING, ['activeDate', this.appointment.day])
    //   let activeRange = this.$store.getters.activeDateRange
    //   if (activeRange.from && activeRange.to) {
    //     let isInRange = moment(this.selectedDate)
    //                       .isBetween(moment(activeRange.from),
    //                                 moment(activeRange.to))
    //     if (!isInRange) {
    //       this.$store.commit(SET_SETTING, ['activeDate', this.appointment.day])
    //       // let start = moment(this.selectedDate).startOf('month').format('YYYY-MM-DD')
    //       // let end = moment(this.selectedDate).endOf('month').format('YYYY-MM-DD')
    //       // this.setGlobalActiveDateRange(start, end)
    //     }
    //   }
    // },
    touch: {
      immediate: true,
      handler () {
        this.clear()
        if (this.relationship && this.relationship.client) {
          this.clientSelected(this.relationship.client)
        }
        // this.debounceGetAppointmentsForDay(true)
      }
    },
    relationship: {
      immediate: true,
      handler () {
        if (this.relationship && this.relationship.client) {
          this.clientSelected(this.relationship.client)
        }
      }
    },
    appointmentDay () {
      this.daymodal = false
      // if (!this.$vuetify.breakpoint.xs) {
        // this.debounceGetAppointmentsForDay()
      this.getAppointmentsForDay()
      // }
    },
    practitionerId () {
      if (this.practitionerId) {
        Vue.set(this.appointment, 'product', {})
        Vue.set(this.appointment, 'service', {})

        this.getAppointmentsForDay()
      }
    }
  },
  computed: {
    ...mapGetters(['getIntegration']),
    isSuccess () {
      return this.getObjectPath(this.savedAppointment, 'id')
    },
    appointmentServiceId () {
      return this.getObjectPath(this.appointment, 'service.id')
    },
    appointmentServiceTitle () {
      return this.getObjectPath(this.appointment, 'service.title')
    },
    hasZoomIntegration () {
      return this.getIntegration('Zoom')
    },
    clientIsSharedWithSelectedSpace () {
      let spaceId = this.appointmentServiceId
      let relationshipSpaces = this.getObjectPath(this.selectedRelationship, 'spaces', [])
      return (relationshipSpaces.indexOf(spaceId) > -1)
    },
    appointmentDay () {
      return this.appointment.day
    },
    appointmentPreview () {
      if (this.savedAppointment && this.savedAppointment.id) { return null }
      if (this.appointment) { return this.appointment }
      return null
    },
    clientFirstName () {
      return this.getObjectPath(this.selectedRelationship, 'client.first_name', null)
    },
    clientLastName () {
      return this.getObjectPath(this.selectedRelationship, 'client.last_name', null)
    },
    clientPhoneNumber () {
      return this.getObjectPath(this.selectedRelationship, 'client.phone_number', null)
    },
    clientEmail () {
      // selectedRelationship.client && selectedRelationship.client.id && !isRealEmail(selectedRelationship.client.email)
      let email = this.getObjectPath(this.selectedRelationship, 'client.email', null)
      if (this.isRealEmail(email)) { return email }
      return null
    },
    dayIsInActiveRange () {
      if (this.appointmentDay) {
        return moment(this.appointment.day).isBetween(this.activeDateRange.from, this.activeDateRange.to)
      }
      return true
    },
    activeDateRange () {
      return this.$store.getters.activeDateRange
    },
    relationshipId () {
      if (this.selectedRelationship && this.selectedRelationship.id) { return this.selectedRelationship.id }
      if (this.appointment && this.appointment.client && this.appointment.client.id) {
        let rel = this.getRelationByClientId(this.appointment.client.id)
        if (rel && rel.id) {
          return rel.id
        }
      }
      return null
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    // getRequest () {
    //   return this.$store.getters.getRequestById(this.getReqId, true)
    // },
    // fetchedAppointments () {
    //   if (this.getRequest.loading) { return [] }
    //   return this.getObjectPath(this.getRequest, 'result.data', [])
    // },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    autoCodes () {
      return this.getObjectPath(this.requests, 'automation.result', [])
    },
    isProductSelected () {
      if (this.appointment.product && this.appointment.product.id) {
        return true
      }
      return false
    },
    spaceId () {
      return this.getObjectPath(this.appointment, 'service.id')
    },
    addressId () {
      return this.getObjectPath(this.appointment, 'address.id')
    },
    operationHoursLink () {
      let spaceId = this.spaceId
      let addressId = this.addressId
      if (spaceId && addressId) {
        return `${LINKS.SETTINGS_SPACES}${spaceId}/locations/${addressId}/hours`
      }
      return false
    },
    dialogVisibility () {
      return this.$store.state.application.activeDialog
    },
    services () {
      return this.$store.getters.services
    },
    isSingleProduct () {
      if (this.services) {
        let isSingleProduct = (this.services &&
              this.services.length === 1 &&
              this.services[0].products.length === 1)

        if (isSingleProduct === true) {
          let service = {
            service: this.services[0],
            product: this.services[0].products[0]
          }
          this.productSelected(service)
        }
        return isSingleProduct
      }
    },
    recurringVerifyRequest () {
      return this.$store.getters.getRequestById(this.reqClashCheckId, true)
    },
    recurringVerifyRequestStatus () {
      return this.recurringVerifyRequest.status
    },
    isCustomEvent () {
      return this.appointment.is_custom
    },
    selectedDate () {
      return this.appointment.day
    },
    selectedServiceTitle () {
      if (this.appointment && this.appointment.service) {
        let title = this.getObjectPath(this.appointment, 'service.title')
        if (!title) {
          title = this.getObjectPath(this.appointment, 'service.address.name')
        }
        return title
      }
      return null
    },
    appointmentIsValid () {
      this.nextfield = null
      if (this.appointment.is_custom) {
        if (!this.appointment.title) {
          this.invalidReason = 'Please provide a title'
          this.nextfield = 'title'
          return false
        }
      } else {
        if (!this.formattedAppointment.product) {
          this.invalidReason = 'Choose an appointment type'
          this.nextfield = 'product'
          return false
        }
      }
      if (!this.appointment.day) {
        this.invalidReason = 'Please choose a date'
        this.nextfield = 'day'
        return false
      }
      if (!this.appointment.start_time) {
        this.invalidReason = 'Choose a start time'
        this.nextfield = 'time'
        return false
      }
      if (!this.appointment.end_time) {
        this.invalidReason = 'Choose an end time'
        this.nextfield = 'time'
        return false
      }
      if (!this.formattedAppointment.client) {
        this.invalidReason = 'Choose a contact person'
        this.nextfield = 'client'
        return false
      }
      if (this.selectCustomTitle && !this.appointment.title) {
        this.invalidReason = 'Please provide a dependant name'
        return false
      }
      return true
    },
    globalStartTime () {
      return this.$store.state.application.globalSettings.startTime
    },
    globalPractitioner () {
      return this.$store.state.application.globalSettings.activePractitioner
    },
    me () {
      return this.$store.getters.me
    },
    hasContacts () {
      if (this.clientPhoneNumber || this.clientEmail) {
        return true
      }
      return false
    },
    practitionerId () {
      if (this.practitioner && this.practitioner.id) { return this.practitioner.id }
      // return this.me.id
    },
    practitionerName () {
      if (this.practitioner) { return this.practitioner.first_name || this.practitioner.full_name }
      return null
    },
    formattedAppointment () {
      let data = {
        'practitioner': this.practitionerId,
        'create_process': this.appointment.create_process
      }
      data.start_time = this.timeStringToMoment(this.appointment.start_time, this.appointment.day)
      data.end_time = this.timeStringToMoment(this.appointment.end_time, this.appointment.day)

      if (this.appointment.product && this.appointment.product.id) {
        data.product = this.appointment.product.id
      }
      if (this.appointment.address && this.appointment.address.id) {
        data.address = this.appointment.address.id
        data.location = this.appointment.address.id
      }
      if (this.appointmentURL) {
        data.zoom_join_url = this.appointmentURL
      }

      if (this.appointment.client) {
        data.title = this.formatFullName(this.appointment.client)
        if (this.appointment.client.custom_id) {
          data.title = `[${this.appointment.client.custom_id}] ${data.title}`
        }
        if (this.selectCustomTitle) {
          data.title = this.appointment.title
          data.full_name = this.appointment.title
        }
        data.client = this.appointment.client.id
      }

      if (this.relationshipId) {
        data.relationships = this.relationshipId
      }

      let comesToYou = this.getObjectPath(this.appointment, 'product.comes_to_you')
      if (comesToYou && this.appointmentLocation) {
        data.location = { name: this.appointmentLocation }
      }

      if (this.appointment.is_custom) {
        data.title = this.appointment.title
        data.client = this.me.id
        data.status = 'B'
        if (data.product) {
          delete data['product']
        }
      }
      return data
    },
    operatingHours () {
      if (this.appointment.day && this.appointment.service && this.appointment.service.id && this.appointment.address && this.appointment.address.id) {
        let addr = this.appointment.address
        let vm = this
        let hours = addr.operation_hours.find((hrs) => {
          return hrs.practitioner === vm.practitionerId
        })
        if (hours) { return hours }
      }
      return null
    },
    selectedDayHours () {
      let hrs = null
      if (this.appointment && this.appointment.day) {
        let day = moment(this.appointment.day).format('ddd').toLocaleLowerCase()
        if (day === 'thu') { day = 'thurs' }
        if (day === 'tue') { day = 'tues' }
        try {
          hrs = this.formatHours(this.operatingHours[day])
        } catch (e) {
          console.error('could not find hours')
        }
      }
      if (hrs) { return hrs }
      return 'Off'
    },
    dayViewSettings () {
      let dayViewSettings = {
        startHour: 6,
        endHour: 20,
        periodInMins: 15
      }
      if (this.operatingHours &&
          this.appointment.product.id &&
          this.appointment.day) {
        let day = moment(this.appointment.day).format('ddd').toLocaleLowerCase()
        if (day === 'thu') { day = 'thurs' }
        if (day === 'tue') { day = 'tues' }
        let hours = this.operatingHours[day]
        if (hours) {
          let timesRanges = hours.split('-')
          let first = timesRanges[0].split(':')[0]
          let last = timesRanges[timesRanges.length - 1].split(':')[0]
          dayViewSettings.startHour = parseInt(first)
          dayViewSettings.endHour = parseInt(last) + 1
          dayViewSettings.defaultNewEventLength = parseInt(this.appointment.product.duration)
        }
      }
      return dayViewSettings
    }
    // events () {
    //   let appointments = this.$store.getters.appointments
    //   if (this.fetchedAppointments && this.fetchedAppointments.length > 0) {
    //     appointments = this.fetchedAppointments
    //   }
    //   appointments
    //     .map((evt) => {
    //       evt['start'] = moment(evt.start_time).format('HH:mm')
    //       evt['end'] = moment(evt.end_time).format('HH:mm')
    //       return evt
    //     })
    //   appointments = appointments.filter((evt) => {
    //     let index = this.ignoredStatuses.indexOf(evt.status.toLowerCase())
    //     return index === -1
    //   })
    //   return appointments
    // }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Create.vue?648cf57b